import { datevSettings } from "./clients.reducer";
import { AuthDataIdentifier, AuthDataType } from "../../../_statics/AuthDataType";
import { UserRole } from "../../../_statics/UserStatics";
import { IntegrationName } from "../../../_statics/Integration";
import { CREDENTIAL_BASED_AUTH_CONNECTIONS, EXTERNAL_AUTH_CONNECTIONS } from "../screens/ClientsScreen";
import stringUtils from "../../../_services/string-utils";
import { sortEnumValues } from "../../../_services/sorting-helper";
import { ConfigurationFieldNames } from "../../../integrations/_statics/ConfigurationStatics";
import { AuthDataStatus } from "../../../_statics/AuthDataStatus";

const EMPTY_PAIR = {
    displayName: null,
    placeholder: "",
};

export const reduceClientsByUsedInConfigurations = (clientReducer, configurations) => {
    if (!clientReducer || !clientReducer.clients || !configurations) {
        return [];
    } else if (clientReducer.clients && configurations.length === 0) {
        return [...clientReducer.clients];
    }

    return [...clientReducer.clients].filter((item) => {
        return (
            configurations.findIndex((config) => {
                return config.hasOwnProperty(ConfigurationFieldNames.PLATFORM_CLIENT_UUID)
                    ? config[ConfigurationFieldNames.PLATFORM_CLIENT_UUID] === item.externalUUID
                    : config.hasOwnProperty(ConfigurationFieldNames.PLATFORM_CLIENT_ID)
                      ? config[ConfigurationFieldNames.PLATFORM_CLIENT_ID] === item.clientId
                      : config[ConfigurationFieldNames.PLATFORM_CLIENT_EXTERNAL_UUID] === item.externalUUID;
            }) === -1
        );
    });
};

export const mapClientToDATEVSettings = (client) => {
    const mappedDATEVSetting = { ...datevSettings };

    mappedDATEVSetting.consultantNumber = client.consultantNumber;
    mappedDATEVSetting.clientNumber = client.clientNumber;
    mappedDATEVSetting.accountNumberLength = client.accountNumberLength;
    mappedDATEVSetting.businessYearMonth = client.businessYearMonth;
    mappedDATEVSetting.businessYearDay = client.businessYearDay;
    mappedDATEVSetting.skr = !stringUtils.isBlank(client.skr) ? client.skr : null;
    mappedDATEVSetting.includeDeliveryDate = client.includeDeliveryDate;

    return mappedDATEVSetting;
};

export const mapClientDATEVInToDATEVSettings = (client, mappedDATEVSetting) => {
    if (client && mappedDATEVSetting) {
        mappedDATEVSetting.consultantNumber = client.consultantNumber;
        mappedDATEVSetting.clientNumber = client.clientNumber;
        mappedDATEVSetting.accountNumberLength = client.accountNumberLength;
        mappedDATEVSetting.businessYearMonth = client.businessYearMonth;
        mappedDATEVSetting.businessYearDay = client.businessYearDay;
        mappedDATEVSetting.skr = !stringUtils.isBlank(client.skr) ? client.skr : null;
        mappedDATEVSetting.includeDeliveryDate = client.includeDeliveryDate ? client.includeDeliveryDate : false;
    }
    return mappedDATEVSetting;
};

export const mapClientPropsToDTO = (client) => {
    const updatedClientDto = { ...client };
    updatedClientDto.name = stringUtils.isBlank(client.name) ? null : client.name;
    updatedClientDto.note = stringUtils.isBlank(client.note) ? null : client.note;
    updatedClientDto.consultantNumber = stringUtils.isBlank(client.consultantNumber) ? null : client.consultantNumber;
    updatedClientDto.clientNumber = stringUtils.isBlank(client.clientNumber) ? null : client.clientNumber;
    updatedClientDto.accountNumberLength = stringUtils.isBlank(client.accountNumberLength)
        ? null
        : client.accountNumberLength;
    updatedClientDto.businessYearMonth = stringUtils.isBlank(client.businessYearMonth) ? "1" : client.businessYearMonth;
    updatedClientDto.businessYearDay = stringUtils.isBlank(client.businessYearDay) ? "1" : client.businessYearDay;
    updatedClientDto.skr = stringUtils.isBlank(client.skr) ? null : client.skr;
    updatedClientDto.includeDeliveryDate = client.includeDeliveryDate ? client.includeDeliveryDate : false;
    return updatedClientDto;
};

export const mapConnectedAuthDataPropsToDTO = (connectedAuthData) => {
    const updatedConnectedAuthDataDto = { ...connectedAuthData };
    updatedConnectedAuthDataDto.key = stringUtils.isBlank(connectedAuthData.key) ? null : connectedAuthData.key;
    updatedConnectedAuthDataDto.value = stringUtils.isBlank(connectedAuthData.value) ? null : connectedAuthData.value;
    updatedConnectedAuthDataDto.token = stringUtils.isBlank(connectedAuthData.token) ? null : connectedAuthData.token;
    updatedConnectedAuthDataDto.sharedSecret = stringUtils.isBlank(connectedAuthData.sharedSecret)
        ? null
        : connectedAuthData.sharedSecret;
    return updatedConnectedAuthDataDto;
};

export const mapClientsToUniqueDatevSettings = (clients) => {
    let datevSettings = [];
    if (clients) {
        datevSettings = clients.map((client) => mapClientToDATEVSettings(client));
    }
    if (datevSettings.length > 0) {
        return datevSettings.filter(
            (currentClient, index) =>
                datevSettings.findIndex(
                    (client) =>
                        client.consultantNumber === currentClient.consultantNumber &&
                        client.clientNumber === currentClient.clientNumber &&
                        client.accountNumberLength === currentClient.accountNumberLength &&
                        client.businessYearMonth === currentClient.businessYearMonth &&
                        client.businessYearDay === currentClient.businessYearDay &&
                        client.skr === currentClient.skr &&
                        client.includeDeliveryDate === currentClient.includeDeliveryDate
                ) === index
        );
    } else {
        return [];
    }
};

export const hasClientEXTFSettings = (client) => {
    return !(
        !client ||
        stringUtils.isEmpty(client.consultantNumber) ||
        stringUtils.isEmpty(client.clientNumber) ||
        stringUtils.isEmpty(client.accountNumberLength) ||
        stringUtils.isEmpty(client.businessYearMonth) ||
        stringUtils.isEmpty(client.businessYearDay)
    );
};

export const mapDatevSettingsIntoClient = (datevSettings, client) => {
    if (datevSettings) {
        const updatedClient = { ...client };
        updatedClient.consultantNumber = datevSettings.consultantNumber ? datevSettings.consultantNumber : "";
        updatedClient.clientNumber = datevSettings.clientNumber ? datevSettings.clientNumber : "";
        updatedClient.accountNumberLength = datevSettings.accountNumberLength ? datevSettings.accountNumberLength : "";
        updatedClient.businessYearMonth = datevSettings.businessYearMonth ? datevSettings.businessYearMonth : "";
        updatedClient.businessYearDay = datevSettings.businessYearDay ? datevSettings.businessYearDay : "";
        updatedClient.skr = !stringUtils.isBlank(datevSettings.skr) ? datevSettings.skr : null;
        updatedClient.includeDeliveryDate = datevSettings.includeDeliveryDate
            ? datevSettings.includeDeliveryDate
            : false;
        return updatedClient;
    } else {
        return client;
    }
};

export const mapClientsToConnectedAuthData = (clients) => {
    let connectedAuthData = [];
    clients.forEach((client) => (connectedAuthData = [...connectedAuthData, ...client.connectedTo]));
    return connectedAuthData;
};

export const mapConnectedAuthDataInputFieldInformation = (connectedAuthData, userRole) => {
    const inputInformation = {
        displayName: "",
        placeholder: "",
    };
    const endpoint = { ...inputInformation };
    const key = { ...inputInformation };
    const value = { ...inputInformation };
    const token = { ...inputInformation };
    const mfaKey = { ...inputInformation };

    if (connectedAuthData.type === AuthDataIdentifier.KAUFLAND) {
        key.displayName = "Client Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Secret Key";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.ZALANDO) {
        endpoint.displayName = "Händler-ID";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "Client-ID";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Client-Secret";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.WOO_COMMERCE) {
        endpoint.displayName = "Shop URL";
        endpoint.placeholder =
            connectedAuthData && !stringUtils.isBlank(connectedAuthData.endpoint)
                ? connectedAuthData.endpoint
                : "https://shopname.de";

        key.displayName = "Consumer Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Consumer Secret";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.SHOPIFY_PRIVATE_APP) {
        endpoint.displayName = "Shop Name";
        endpoint.placeholder =
            connectedAuthData && !stringUtils.isBlank(connectedAuthData.endpoint)
                ? connectedAuthData.endpoint
                : "shopname.myshopify.com";

        key.displayName = "API Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "API Password";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        token.displayName = "Access Token";
        token.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.token
            : stringUtils.anonymizeKeep5(connectedAuthData.token);

        const sharedSecret = { ...inputInformation };
        sharedSecret.displayName = "Shared Secret";
        sharedSecret.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.sharedSecret
            : stringUtils.anonymizeKeep5(connectedAuthData.sharedSecret);

        return { endpoint: endpoint, key: key, value: value, token: token, sharedSecret: sharedSecret };
    } else if (connectedAuthData.type === AuthDataIdentifier.KLARNA) {
        endpoint.displayName = "Klarna API - Benutzername";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "Klarna API - Password";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = null;
        value.placeholder = "";

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.BRAINTREE) {
        key.displayName = "Public Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        endpoint.displayName = "Merchant ID";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        value.displayName = "Private Key";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.ADYEN) {
        endpoint.displayName = "Webhook Username";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "Webhook Password";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Download Report API Key";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);
        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.BILLBEE) {
        endpoint.displayName = "API Key";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "Username";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Password";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.FASTBILL) {
        key.displayName = "Username";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Password";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: EMPTY_PAIR, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.GOCARDLESS) {
        key.displayName = "GoCardless Credentials";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.SNIPCART) {
        endpoint.displayName = null;
        endpoint.placeholder = "";

        key.displayName = "API Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = null;
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.MOLLIE_ACCESS_KEY) {
        key.displayName = "Access Token";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: EMPTY_PAIR, key: key, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.UNZER) {
        const UNZER_KB_URL =
            "https://hilfe.pathway-solutions.de/de/knowledge/payment-anbieter/unzer-api-verbinden";
        endpoint.displayName = "FTP Pfad (optional - nur benötigt wenn PayLater genutzt wird)";
        endpoint.tooltip = "Diese Info kommt von Unzer und ist i.d.R. euer Firmenname in Kleinbuchstaben.";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);
        key.displayName = "Username";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);
        value.displayName = "Passwort";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        mfaKey.displayName = "2FA-Schlüssel";
        mfaKey.kbLink = UNZER_KB_URL;
        // It's always censored by default
        mfaKey.placeholder = connectedAuthData.mfaKey;

        return { endpoint: endpoint, key: key, value: value, mfaKey: mfaKey };
    } else if (connectedAuthData.type === AuthDataIdentifier.SQUARESPACE) {
        key.displayName = "API Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: EMPTY_PAIR, key: key, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.ABOUT_YOU_API_KEY) {
        key.displayName = "About You API Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: EMPTY_PAIR, key: key, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.STRIPE_API_KEY) {
        key.displayName = "API Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: EMPTY_PAIR, key: key, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.CHARGEBEE) {
        endpoint.displayName = "Chargebee Seite (ohne .chargebee.com)";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "Chargebee Credentials (API Key)";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: endpoint, key: key, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.WECLAPP) {
        endpoint.displayName = "Domain";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "API Token";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        return { endpoint: endpoint, key: key, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.XENTRAL) {
        endpoint.displayName = "API Endpunkt";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        key.displayName = "Benutzername";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Passwort";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.AMAZON_PAY) {
        endpoint.displayName = "Passwort";
        endpoint.placeholder = connectedAuthData.endpoint;

        key.displayName = "Access Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Secret Key";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: endpoint, key: key, value: value };
    } else if (connectedAuthData.type === AuthDataIdentifier.DATEV_UO_REF) {
        return { endpoint: EMPTY_PAIR, key: EMPTY_PAIR, value: EMPTY_PAIR };
    } else if (connectedAuthData.type === AuthDataIdentifier.AMAZON_PAY_V2) {
        key.displayName = "Public Key";
        key.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.key
            : stringUtils.anonymizeKeep5(connectedAuthData.key);

        value.displayName = "Upload Private Key";
        value.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.value
            : stringUtils.anonymizeKeep5(connectedAuthData.value);

        return { endpoint: EMPTY_PAIR, key: key, value: value };
    } else if (
        connectedAuthData.type === AuthDataIdentifier.PAYPAL &&
        connectedAuthData.status === AuthDataStatus.SETUP
    ) {
        endpoint.displayName = "Merchant ID";
        endpoint.placeholder = [UserRole.SUPER_USER, UserRole.ADMINISTRATOR].includes(userRole)
            ? connectedAuthData.endpoint
            : stringUtils.anonymizeKeep5(connectedAuthData.endpoint);

        return { endpoint: endpoint, key: EMPTY_PAIR, value: EMPTY_PAIR };
    } else {
        return { endpoint: EMPTY_PAIR, key: EMPTY_PAIR, value: EMPTY_PAIR };
    }
};

export const mapConnectAuthDataTypeToIntegrationName = (authDataType) => {
    if (
        [
            AuthDataIdentifier.SHOPIFY_PRIVATE_APP,
            AuthDataIdentifier.SHOPIFY_APPSTORE_BILLING,
            AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM,
        ].includes(authDataType)
    ) {
        return IntegrationName.SHOPIFY;
    } else if (stringUtils.equals(AuthDataIdentifier.STRIPE_CONNECT, authDataType)) {
        return IntegrationName.STRIPE;
    } else {
        return IntegrationName[String(authDataType)];
    }
};

export const reduceCommonAuthDataTypesByNonOAuth = (commonAvailableConnections) => {
    return commonAvailableConnections.filter((connection) => {
        return (
            CREDENTIAL_BASED_AUTH_CONNECTIONS.findIndex(
                (connectionType) => connectionType === connection.enumIdentifier
            ) !== -1
        );
    });
};

// Connections that should always be offered in the "Verfügbare Verbindungen" dropdown, regardless of
// whether the corresponding module has been activated under "Weitere Integrationen" (see issue #41843).
export const SELECTABLE_CONNECTIONS = [
    AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM,
    AuthDataIdentifier.SHOPIFY_APPSTORE_BILLING,
    AuthDataIdentifier.AMAZON,
    AuthDataIdentifier.EBAY_OAUTH,
    AuthDataIdentifier.KAUFLAND,
    AuthDataIdentifier.OTTO_OAUTH,
    AuthDataIdentifier.TIKTOK_OAUTH,
    AuthDataIdentifier.WOO_COMMERCE,
    AuthDataIdentifier.ZALANDO,
    AuthDataIdentifier.PAYPAL,
    AuthDataIdentifier.ADYEN,
    AuthDataIdentifier.BRAINTREE,
    AuthDataIdentifier.GOCARDLESS,
    AuthDataIdentifier.KLARNA,
    AuthDataIdentifier.MOLLIE,
    AuthDataIdentifier.UNZER,
    AuthDataIdentifier.STRIPE_CONNECT,
    AuthDataIdentifier.XENTRAL,
    AuthDataIdentifier.ABOUT_YOU_API_KEY,
    AuthDataIdentifier.DATEV_UO_REF

];

// Alternate/deprecated/self-managed connection types that must never appear in the generic
// "Verfügbare Verbindungen" dropdown — they either have a dedicated flow or have been superseded.
const NON_SELECTABLE_CONNECTIONS = [
    AuthDataIdentifier.AMAZON_PAY, // deprecated; superseded by AMAZON_PAY_V2
    AuthDataIdentifier.MOLLIE_ACCESS_KEY, // alternate to the OAuth-based Mollie flow
    AuthDataIdentifier.DATEV_UO, // handled by the dedicated DATEV connection UI
    AuthDataIdentifier.SHOPIFY_PRIVATE_APP, // deprecated; superseded by the Shopify Appstore connections
];

// True if any integration/module behind the given connection type is in the organization's allowedApps.
export const isConnectionModuleActivated = (enumIdentifier, allowedApps) => {
    if (!allowedApps || allowedApps.length === 0) {
        return false;
    }
    const authDataType = AuthDataType[enumIdentifier];
    if (!authDataType) {
        return false;
    }
    return authDataType.integrations.some((integration) => allowedApps.includes(integration.identifier));
};

// The Shopify "Rechnungsprinter" connection (SHOPIFY_APPSTORE_BILLING) has no integration of its own,
// so isConnectionModuleActivated never treats it as activated. Pin it to the top alongside the Shopify
// "Buchhaltungsexport" connection (SHOPIFY_APPSTORE_PLATFORM) whenever the Shopify module is active
// (issue #41843 feedback).
const isConnectionActivatedForSorting = (enumIdentifier, allowedApps) => {
    if (enumIdentifier === AuthDataIdentifier.SHOPIFY_APPSTORE_BILLING) {
        return isConnectionModuleActivated(AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM, allowedApps);
    }
    return isConnectionModuleActivated(enumIdentifier, allowedApps);
};

// Builds the list of connections shown in the "Verfügbare Verbindungen" dropdown (issue #41843):
//   1. connections whose module is activated but which have no connection yet -> top
//   2. remaining selectable connections
//   3. connections the client is already connected to are omitted entirely
export const buildSelectableConnections = (authDataTypes, client, allowedApps, userRole) => {
    if (!authDataTypes) {
        return [];
    }
    const isSuperUser = stringUtils.equals(userRole, UserRole.SUPER_USER);

    const selectable = authDataTypes.filter((connection) => {
        const identifier = connection.enumIdentifier;

        // Never offer deprecated/alternate/self-managed connection types here.
        if (NON_SELECTABLE_CONNECTIONS.includes(identifier)) {
            return false;
        }
        // The Stripe API-key connection is reserved for super users.
        if (identifier === AuthDataIdentifier.STRIPE_API_KEY && !isSuperUser) {
            return false;
        }
        // Rule 3: hide connections the client is already connected to.
        if (hasClientConnectedAuthData(client, identifier)) {
            return false;
        }
        // The curated list is always selectable; additionally keep any connection whose module is
        // already activated so nothing currently visible for the organization disappears.
        return SELECTABLE_CONNECTIONS.includes(identifier) || isConnectionModuleActivated(identifier, allowedApps);
    });

    // Rules 1 & 2: activated-but-unconnected connections first, then the rest (alphabetical within each group).
    const activatedButUnconnected = selectable.filter((connection) =>
        isConnectionActivatedForSorting(connection.enumIdentifier, allowedApps)
    );
    const remaining = selectable.filter(
        (connection) => !isConnectionActivatedForSorting(connection.enumIdentifier, allowedApps)
    );

    return [...sortEnumValues(activatedButUnconnected), ...sortEnumValues(remaining)];
};

// Returns the module/integration identifiers that must be added to allowedApps so that a freshly created
// connection is immediately usable. OAuth-based connections activate their module on the backend, so only
// credential-based connections need to be co-activated from the frontend (issue #41843).
export const getModulesToActivateForConnection = (type, allowedApps) => {
    const authDataType = AuthDataType[type];
    if (!authDataType || EXTERNAL_AUTH_CONNECTIONS.includes(type)) {
        return [];
    }
    const currentApps = allowedApps || [];
    return authDataType.integrations
        .map((integration) => integration.identifier)
        .filter((identifier) => !currentApps.includes(identifier));
};

export const getClientNameForConnectedAuthData = (clients, connectedAuthData) => {
    const client = clients.find((client) => client.externalUUID === connectedAuthData.clientUUID);
    return client ? client.name : "";
};

export const checkConnectionToIntegration = (client, authDataType) => {
    for (const authDataIdentifier of authDataType.authDataIdentifiers) {
        if (hasClientConnectedAuthData(client, authDataIdentifier.identifier)) {
            return authDataIdentifier;
        }
    }
    return null;
};

export const findConnectedAuthDataForIntegrationIdentifier = (client, integrationIdentifier) => {
    const authDataForIntegration = Object.values(AuthDataType).filter((authDataType) => {
        return authDataType.integrations.findIndex((i) => i.identifier === integrationIdentifier) > -1;
    });
    return authDataForIntegration.find((authData) => hasClientConnectedAuthData(client, authData.identifier));
};

export const findValidConnectedAuthDataForIntegrationIdentifier = (client, integrationIdentifier) => {
    const authDataForIntegration = Object.values(AuthDataType).filter((authDataType) => {
        return authDataType.integrations.findIndex((i) => i.identifier === integrationIdentifier) > -1;
    });
    return authDataForIntegration.find((authData) => hasValidConnectedAuthData(client, authData.identifier));
};

export const hasClientConnectedAuthData = (client, authDataIdentifier) => {
    if (client && client.connectedTo) {
        if (
            stringUtils.equals(authDataIdentifier, AuthDataIdentifier.SHOPIFY_PRIVATE_APP) ||
            stringUtils.equals(authDataIdentifier, AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM)
        ) {
            const connections = client.connectedTo.filter(
                (connectedAuthData) =>
                    stringUtils.equals(connectedAuthData.type, AuthDataIdentifier.SHOPIFY_PRIVATE_APP) ||
                    stringUtils.equals(connectedAuthData.type, AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM)
            );
            return connections.length > 0;
        } else if (
            stringUtils.equals(authDataIdentifier, AuthDataIdentifier.MOLLIE) ||
            stringUtils.equals(authDataIdentifier, AuthDataIdentifier.MOLLIE_ACCESS_KEY)
        ) {
            const connections = client.connectedTo.filter(
                (connectedAuthData) =>
                    stringUtils.equals(connectedAuthData.type, AuthDataIdentifier.MOLLIE) ||
                    stringUtils.equals(connectedAuthData.type, AuthDataIdentifier.MOLLIE_ACCESS_KEY)
            );
            return connections.length > 0;
        }
        const connections = client.connectedTo.filter(
            (connectedAuthData) => connectedAuthData.type === authDataIdentifier
        );
        return connections.length > 0;
    } else {
        return false;
    }
};

export const hasAnyValidConnectedAuthData = (client, authDataIdentifierList) => {
    return (
        authDataIdentifierList.findIndex((authDataIdentifier) =>
            hasValidConnectedAuthData(client, authDataIdentifier)
        ) > -1
    );
};

export const hasValidConnectedAuthData = (client, authDataIdentifier) => {
    if (stringUtils.equals(authDataIdentifier, AuthDataIdentifier.ADYEN)) {
        return true;
    }
    return (
        client &&
        client.connectedTo.filter((authData) => authData.status === "VALID" && authData.type === authDataIdentifier)
            .length > 0
    );
};

export const hasAnySetupConnectedAuthData = (client, authDataIdentifierList) => {
    return (
        authDataIdentifierList.findIndex((authDataIdentifier) =>
            hasSetupConnectedAuthData(client, authDataIdentifier)
        ) > -1
    );
};

export const hasSetupConnectedAuthData = (client, authDataIdentifier) => {
    return (
        client &&
        client.connectedTo.filter((authData) => authData.status === "SETUP" && authData.type === authDataIdentifier)
            .length > 0
    );
};

export const getAnyValidAuthDataOfClient = (client, authDataIdentifierList) => {
    if (!client) {
        return null;
    }
    const availableConnections = authDataIdentifierList.findIndex((authDataIdentifier) => {
        return (
            client.connectedTo.filter((connectedAuthData) => connectedAuthData.type === authDataIdentifier).length > 0
        );
    });

    return availableConnections.length > 0 ? availableConnections[0] : null;
};

export const getConnectedAuthDataFromClientByType = (client, type) => {
    if (
        stringUtils.equals(type, AuthDataIdentifier.SHOPIFY_PRIVATE_APP) ||
        stringUtils.equals(type, AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM)
    ) {
        return client.connectedTo.find(
            (connectedAuthData) =>
                stringUtils.equals(connectedAuthData.type, AuthDataIdentifier.SHOPIFY_PRIVATE_APP) ||
                stringUtils.equals(connectedAuthData.type, AuthDataIdentifier.SHOPIFY_APPSTORE_PLATFORM)
        );
    }
    return client.connectedTo.find((connectedAuthData) => connectedAuthData.type === type);
};

export const getClientByExternalUUIDFromClients = (clients, clientUUID) => {
    return clients.find((client) => stringUtils.equals(client.externalUUID, clientUUID));
};

export const getClientByIdDFromClients = (clients, clientId) => {
    return clients.find((client) => stringUtils.equals(client.clientId, clientId));
};

export const getAccountNumberLengthFromClientsByExternalUUID = (clients, clientExternalUUID) => {
    let client = getClientByExternalUUIDFromClients(clients, clientExternalUUID);
    if (!client) {
        client = getClientByIdDFromClients(clients, clientExternalUUID);
    }
    if (client) {
        return client.accountNumberLength;
    } else {
        return "4";
    }
};

export const getSKRFromClientsByExternalUUID = (clients, clientExternalUUID) => {
    let client = getClientByExternalUUIDFromClients(clients, clientExternalUUID);
    if (!client) {
        client = getClientByIdDFromClients(clients, clientExternalUUID);
    }
    if (client) {
        return client.skr;
    }
};

export const mapAccessDataToConnectedAuthData = (accessData, connectedAuthData) => {
    connectedAuthData.key = accessData.key;
    connectedAuthData.value = accessData.value;
    connectedAuthData.token = accessData.token;
    connectedAuthData.sharedSecret = accessData.sharedSecret;
    return connectedAuthData;
};
